import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

async function getTableNotesOrders({ orgId, tableId }) {
  try {
    const ordersQuery = query(
      collection(db, "Orders"),
      where("orgId", "==", orgId),
      where("fromTable", "==", tableId),
      where("toBePaid", "==", true),
    );

    const ordersSnapshot = await getDocs(ordersQuery);

    const orders = ordersSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return orders;
  } catch (error) {
    console.error("Error getting documents: ", error);
    return [];
  }
}
export default getTableNotesOrders;
